// extracted by mini-css-extract-plugin
export default {"link":"MenuLink_link__CN+uE"};